module.exports = __webpack_public_path__ + "static/img/vFive1.fb07a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vFive1.png
// module id = 3v2y
// module chunks = 2